import { GET_ORG_OTC_SUCCESS, RESET_OTC_STATE } from '../actions/types';

export const resetOtcState = () => {
    return {
        type: RESET_OTC_STATE
    };
};

export const getOtcCodesSuccess = otcCodes => {
    return {
        type: GET_ORG_OTC_SUCCESS,
        payload: otcCodes
    };
};
